module.exports = __webpack_public_path__ + "static/img/8.e4bddeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/clix/8.png
// module id = +bL/
// module chunks = 35